import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import i18n from '@/plugins/i18n';
import moment from 'moment';
import VueMapbox from 'vue-mapbox';
import Mapbox from 'mapbox-gl';
import './styles/app.scss';
import Slick from "vue-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import breadcrumbsbanner from '@/components/breadcrumbBanner.vue';
import Carousel3d from 'vue-carousel-3d';

Vue.component("Slick", Slick);
Vue.component('breadcrumbs-banner', breadcrumbsbanner);
Vue.config.productionTip = false;
Vue.prototype.moment = moment;
moment.locale(i18n.locale);

new Vue({
	router,
	store,
	vuetify,
	i18n,
	moment,
	VueMapbox,
	Carousel3d,
	mapboxgl: Mapbox,
	render: (h) => h(App)
}).$mount('#app');
